import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

export const Bundle = () => {
  return (
    <section id="bundle" className="py-24 bg-[#0a192f] relative overflow-hidden">
      {/* Decorative Wave SVG */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-none rotate-180">
        <svg className="relative block w-full h-[50px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="fill-[#f8fafc]"></path>
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 mt-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="order-2 lg:order-1"
          >
            <div className="inline-flex items-center space-x-2 bg-[#93e9be]/10 rounded-full px-4 py-2 mb-6 border border-[#93e9be]/30">
              <SafeIcon name="Zap" className="h-5 w-5 text-[#ff7f50]" />
              <span className="text-[#93e9be] font-bold text-sm tracking-wide uppercase">Ultimate Value</span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-black text-white mb-6 leading-tight">
              THE STARTER <br/><span className="text-[#ff7f50]">QUIVER BUNDLE</span>
            </h2>
            
            <p className="text-gray-300 text-lg mb-8">
              Everything you need to hit the lineup. Hand-selected by our pros to ensure you have the perfect setup from day one. Save 20% when you bundle.
            </p>
            
            <ul className="space-y-4 mb-10">
              {['Any Stock Shortboard or Fish', 'Premium 6ft Surf Leash', 'FCS II Fin Set', '3-Pack of Sticky Bumps Wax', 'Tidecraft Board Bag'].map((item, i) => (
                <li key={i} className="flex items-center text-gray-200">
                  <SafeIcon name="CheckCircle" className="h-6 w-6 text-[#93e9be] mr-3 flex-shrink-0" />
                  <span className="font-medium">{item}</span>
                </li>
              ))}
            </ul>
            
            <div className="flex flex-col sm:flex-row items-center gap-6">
              <button className="w-full sm:w-auto bg-[#ff7f50] text-white px-10 py-5 rounded-full font-bold text-lg shadow-[0_0_20px_rgba(255,127,80,0.4)] hover:bg-[#e66c3e] transition-all hover:-translate-y-1">
                Build Your Bundle - $799
              </button>
              <span className="text-gray-400 line-through text-xl font-bold">$985 Value</span>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="order-1 lg:order-2 relative"
          >
            {/* Abstract Background Shape */}
            <div className="absolute inset-0 bg-[#93e9be] rounded-full blur-[100px] opacity-20 transform translate-x-10 translate-y-10"></div>
            
            <div className="relative rounded-tl-[4rem] rounded-br-[4rem] rounded-tr-xl rounded-bl-xl overflow-hidden border-4 border-[#0f294d] shadow-2xl">
              <img 
                src="https://images.unsplash.com/photo-1512552288040-07cece97a3a0?q=80&w=2070&auto=format&fit=crop" 
                alt="Surfboard bundle on the beach" 
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute top-6 right-6 bg-[#0a192f] text-white p-4 rounded-full border-2 border-[#ff7f50] transform rotate-12 shadow-lg">
                <div className="text-center">
                  <span className="block text-xs uppercase tracking-wider font-bold text-[#93e9be]">Save</span>
                  <span className="block text-2xl font-black">20%</span>
                </div>
              </div>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};